<script lang="ts" setup>
import { computed } from "vue"; // Properties

// Properties
const props = defineProps({
    modelValue: {
        type: [String, Boolean, Number],
        default: "",
    },
    type: {
        type: String,
        default: "text",
    },
    errorMsg: {
        type: String,
        default: "",
    },
    placeholder: {
        type: String,
        default: "Search...",
    },
});

// Data
const emit = defineEmits(["update:modelValue"]);

const model = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        return emit("update:modelValue", value);
    },
});
</script>

<template>
    <div
        class="relative mb-3 flex flex-1 rounded-2xl border border-gray-300 px-4 hover:border-gray-400 md:mr-0 md:mb-0"
    >
        <input
            v-model="model"
            type="text"
            :placeholder="placeholder"
            class="flex-1 py-1 pl-2 text-base focus:outline-hidden"
        />
        <span v-show="!model" class="flex-none pt-1.5">
            <NuxtImg src="/images/header/mag_glass.svg" class="w-6" />
        </span>
        <span v-show="model" class="absolute right-5 cursor-pointer pt-2" @click="model = ''">
            <NuxtImg src="/images/fa/x-regular-duotone.svg" class="w-3" />
        </span>
    </div>
</template>
